<template>
  <div id="login" class="zindex10">
    <!-- <img class="bgmarmoleado" src="../assets/imgs/raspaygana/marmoleado-azul.png" alt="Bg"> -->

    <section class="bannerprincipal text-center">
      <div class="row pt-5">
        <div class="col-6 offset-3 col-lg-4 offset-lg-4">
          <img
            class="img-fluid"
            src="../assets/imgs/dominos/dominos-logo.png"
            alt="Domino's Pizza"
          />
        </div>

        <div class="col-10 offset-1 col-lg-4 offset-lg-4 py-5">
          <img
            class="img-fluid"
            src="../assets/imgs/dominos/solo-en-mexico-solo-en-dominos.png"
            alt="Domino's Pizza"
          />
        </div>
      </div>
    </section>

    <section>
      <div class="container pt-lg-0">
        <div class="row pb-5">
          <!-- <div class="col-12 col-lg-6 posrel">
            <router-link
              to="/registro"
              class="btnaction fG bold text-center pointer"
            >
              REGÍSTRATE AQUÍ
            </router-link>
          </div>
          <div class="col-12 py-5 d-lg-none fG bold text-center w-100">
            ó
          </div> -->
          <div class="col-12 col-lg-6 offset-lg-3" id="iniciar-sesion">
            <div class="row" v-if="showLoginForm">
              <form @submit="login($event)" class="col-12">
                <div class="">
                  <div class="d-flex flex-column">
                    <div class="w-100 px-2">
                      <input
                        v-model.trim="loginForm.email"
                        type="email"
                        placeholder="E-mail"
                        id="email1"
                        class="text-left"
                        required
                      />
                    </div>
                    <div class="w-100 px-2 position-relative">
                      <input
                        v-model.trim="loginForm.password"
                        :type="showPasswordLogin ? 'text' : 'password'"
                        placeholder="Contraseña"
                        id="password1"
                        class="text-left pr-5"
                        required
                      />
                      <span
                        class="position-absolute pointer"
                        style="
                          right: 20px;
                          top: 35%;
                          transform: translateY(-50%);
                        "
                        @click="showPasswordLogin = !showPasswordLogin"
                      >
                        <img
                          v-if="showPasswordLogin"
                          src="../assets/imgs/icons/eye-open.png"
                          alt="Ocultar"
                          style="width: 35px; cursor: pointer"
                        />
                        <img
                          v-else
                          src="../assets/imgs/icons/eye-closed.png"
                          alt="Mostrar"
                          style="width: 35px; cursor: pointer"
                        />
                      </span>
                    </div>

                    <div
                      class="px-2 text-center d-flex align-items-center pt-3"
                    >
                      <button
                        type="submit"
                        class="azul pointer d-flex align-items-center justify-content-center bold btnaction fG ml-auto mr-auto w-100"
                      >
                        INICIA SESIÓN
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 pb-5">
            <div class="extras text-right">
              <a
                @click="togglePasswordReset()"
                class="pointer rojo bold underlined"
                >Olvidé mi contraseña</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="dominos-promo">
      <div class="container-fluid px-0 promo-wrapper">
        <!-- BLOQUE 1 -->
        <div class="promo-block position-relative">
          <div class="red-line top-line"></div>

          <!-- <div class="step-badge step-1">
            <img :src="paso1" alt="Paso 1" class="img-fluid" />
          </div> -->

          <div class="row g-0 align-items-stretch block-row bgazulclaro no-gutters">
            <div class="col-6 d-flex align-items-center">
              <div class="text-box ps-3 pe-2">
                <div class="small-title pl-3">Compra tus</div>
                <div class="main-title pl-3">DOMINO’S</div>
                <div class="small-title pl-3">favoritas</div>
              </div>
            </div>

            <div class="col-6">
              <img
                :src="paso1Img"
                alt="Pizza Domino's"
                class="img-fluid w-100 h-100 block-image cover-img"
              />
            </div>
          </div>
        </div>

        <!-- BLOQUE 2 -->
        <!-- <div class="promo-block position-relative">
          <div class="red-line"></div>

          <div class="step-badge step-2">
            <img :src="paso2" alt="Paso 2" class="img-fluid" />
          </div>

          <div class="row g-0 align-items-center block-row block-row-2">
            <div class="col-5 text-center">
              <img :src="paso2Img" alt="Ticket" class="img-fluid ticket-img" />
            </div>

            <div class="col-7">
              <div class="register-text pe-3">
                Registra tu ticket<br />
                <router-link to="/registro" class="underline-text azul"
                  >aquí</router-link
                >
                o vía
                <a target="_blank" href="https://api.whatsapp.com/send/?phone=5215645351666&text=%C2%A1Quiero+participar+en+la+promoci%C3%B3n+Solo+en+Domino%27s%21&type=phone_number&app_absent=0" rel="noopener noreferrer" class="underline-text azul">WhatsApp</a>
              </div>
            </div>
          </div>
        </div> -->

        
        <div class="promo-block position-relative">
          <div class="red-line"></div>

          <!-- <div class="step-badge step-3">
            <img :src="paso2" alt="Paso 3" class="img-fluid" />
          </div> -->

          <div class="row g-0 align-items-center block-row block-row-3">
            <div class="col-6 d-flex align-items-center">
              <div class="win-text ps-3  pl-3">
                Entre + compres<br />
                + oportunidades<br />
                tienes de ganar

                <div class="red-pill mt-2">Playeras y TVs</div>
              </div>
            </div>

            <div class="col-6 text-center pe-2">
              <img :src="paso3Img" alt="Premios" class="img-fluid prizes-img" />
            </div>
          </div>
        </div>

       
        <div class="container-fluid px-3 bottom-content">
          <div class="goals-text text-center">
            Cada $ de tu ticket = 1 Gol Domino’s.
          </div>

          <div class="winners-box text-center">
            ¡Son 20 ganadores<br />
            cada semana!
          </div>

          <div class="buttons-area text-center">
            <!-- <router-link to="/registro" class="btn promo-btn"
              >REGÍSTRATE AQUÍ</router-link
            > -->

            <a
              href="javascript:void(0)"
              @click.prevent="scrollToLogin"
              class="btn promo-btn"
            >
              INICIAR SESIÓN
            </a>

            <router-link to="/ganadores" class="btn promo-btn btn-small">
              CONSULTAR GANADORES
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section id="fondo">
      <div class="container">
        <div class="row">
          <div class="col-12 zindex10">
            <div class="row">
              <!-- <div class="col-12">
                <form @submit="signup($event)" class="py-5 r15">
                  <div class="col-12 text-center pb-4 azul zindex10">
                    <h2>
                      <span class="bold amarillo">Regístrate aquí</span>
                    </h2>
                  </div>
                  <div class="col-12 zindex10">
                    <div class="row pb-4">
                      <div class="col-lg-6 pb-3">
                        
                          v-model.trim="signupForm.nombre"
                          type="text"
                          placeholder="Nombre Completo"
                          id="nombre"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <div class="fG azul">Apellido</div>
                        <input
                          v-model.trim="signupForm.apellido"
                          type="text"
                          placeholder="Apellido"
                          id="apellido"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                      
                        <input
                          v-model.trim="signupForm.email"
                          type="email"
                          placeholder="Correo electrónico"
                          id="email2"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        
                        <input
                          v-model.trim="signupForm.celular"
                          type="text"
                          placeholder="Teléfono (10 dígitos)"
                          id="celular"
                          maxlength="10"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <input
                          v-model.trim="signupForm.fecha_nacimiento"
                          :type="dateType"
                          placeholder="Fecha de nacimiento (DD/MM/AAAA)"
                          id="fecha_nacimiento"
                          @click="cambiaFechaType()"
                          @focus="cambiaFechaType()"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        
                        <select
                          id="estado"
                          name="estado"
                          class="form-select"
                          v-model.trim="signupForm.estado"
                          required
                        >
                          <option value="">Estado</option>
                          <option value="Aguascalientes">Aguascalientes</option>
                          <option value="Baja California">
                            Baja California
                          </option>
                          <option value="Baja California Sur">
                            Baja California Sur
                          </option>
                          <option value="Campeche">Campeche</option>
                          <option value="Chiapas">Chiapas</option>
                          <option value="Chihuahua">Chihuahua</option>
                          <option value="Ciudad de México">
                            Ciudad de México
                          </option>
                          <option value="Coahuila">Coahuila</option>
                          <option value="Colima">Colima</option>
                          <option value="Durango">Durango</option>
                          <option value="Estado de México">
                            Estado de México
                          </option>
                          <option value="Guanajuato">Guanajuato</option>
                          <option value="Guerrero">Guerrero</option>
                          <option value="Hidalgo">Hidalgo</option>
                          <option value="Jalisco">Jalisco</option>
                          <option value="Michoacán">Michoacán</option>
                          <option value="Morelos">Morelos</option>
                          <option value="Nayarit">Nayarit</option>
                          <option value="Nuevo León">Nuevo León</option>
                          <option value="Oaxaca">Oaxaca</option>
                          <option value="Puebla">Puebla</option>
                          <option value="Querétaro">Querétaro</option>
                          <option value="Quintana Roo">Quintana Roo</option>
                          <option value="San Luis Potosí">
                            San Luis Potosí
                          </option>
                          <option value="Sinaloa">Sinaloa</option>
                          <option value="Sonora">Sonora</option>
                          <option value="Tabasco">Tabasco</option>
                          <option value="Tamaulipas">Tamaulipas</option>
                          <option value="Tlaxcala">Tlaxcala</option>
                          <option value="Veracruz">Veracruz</option>
                          <option value="Yucatán">Yucatán</option>
                          <option value="Zacatecas">Zacatecas</option>
                        </select>
                      </div>
                      <div class="col-lg-6 pb-3">
                        
                        <input
                          v-model.trim="signupForm.cp"
                          type="text"
                          placeholder="C.P."
                          id="cp"
                          required
                          pattern="^\d{5}$"
                          maxlength="5"
                          title="Debe contener exactamente 5 dígitos"
                        />
                      </div>
                      <div class="col-lg-6 pb-3 position-relative">
                        <input
                          v-model.trim="signupForm.password"
                          :type="showPasswordSignup1 ? 'text' : 'password'"
                          placeholder="Contraseña"
                          id="password"
                          required
                          class="pr-5"
                        />
                        <span
                          class="position-absolute pointer"
                          style="
                            right: 20px;
                            top: 35%;
                            transform: translateY(-50%);
                          "
                          @click="showPasswordSignup1 = !showPasswordSignup1"
                        >
                          <img
                            v-if="showPasswordSignup1"
                            src="../assets/imgs/icons/eye-open.png"
                            alt="Ocultar"
                            style="width: 35px; cursor: pointer"
                          />
                          <img
                            v-else
                            src="../assets/imgs/icons/eye-closed.png"
                            alt="Mostrar"
                            style="width: 35px; cursor: pointer"
                          />
                        </span>
                      </div>

                      <div class="col-lg-6 pb-3 position-relative">
                        <input
                          v-model.trim="signupForm.password2"
                          :type="showPasswordSignup2 ? 'text' : 'password'"
                          placeholder="Confirma Contraseña"
                          id="password2"
                          required
                          class="pr-5"
                        />
                        <span
                          class="position-absolute pointer"
                          style="
                            right: 20px;
                            top: 35%;
                            transform: translateY(-50%);
                          "
                          @click="showPasswordSignup2 = !showPasswordSignup2"
                        >
                          <img
                            v-if="showPasswordSignup2"
                            src="../assets/imgs/icons/eye-open.png"
                            alt="Ocultar"
                            style="width: 35px; cursor: pointer"
                          />
                          <img
                            v-else
                            src="../assets/imgs/icons/eye-closed.png"
                            alt="Mostrar"
                            style="width: 35px; cursor: pointer"
                          />
                        </span>
                      </div>

                     

                      <div class="col-12 pb-3 text-center azul">
                        <label>
                          <input
                            type="checkbox"
                            v-model="signupForm.terminosedad"
                            required
                          />
                          Confirmo que soy mayor de edad
                        </label>
                      </div>
                      <div class="col-12 pb-3 text-center azul">
                        <label>
                          <input
                            type="checkbox"
                            v-model="signupForm.terminos"
                            required
                          />
                          He leído y acepto el
                          <a
                            href="#"
                            class="azul underlined"
                            target="_blank"
                            rel="noopener noreferrer"
                            >Aviso de Privacidad</a
                          >
                        </label>
                      </div>
                      <div class="col-12 pb-3 text-center azul">
                        <label>
                          <input
                            type="checkbox"
                            v-model="signupForm.terminoscondiciones"
                            required
                          />
                          Acepto los términos y Condiciones
                        </label>
                      </div>
                    </div>
                    <div class="row pb-5">
                      <div class="col-12 text-center">
                        <button
                          type="submit"
                          class="amarillo pointer d-flex align-items-center justify-content-center btnaction2 fG ml-auto mr-auto w-100 bold"
                        >
                          Registrarme
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div> -->
            </div>
          </div>
        </div>

        <!-- <div class="row py-5">
          <div class="col-12 text-center azul fXXG">GANADORES</div>
          <div class="col-12 text-center  azul fG py-2">Consulta la lista de ganadores semanales aquí:</div>
          <div class="col-12 text-center pb-5">
            <router-link
              to="/ganadores"
              class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Lista de ganadores semanales
            </router-link>
          </div>
        </div> -->
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>

    <div class="overlayfull" v-if="overlay_sucursal === true">
      <div class="bg-overlay" @click="toggleSucursal"></div>
      <div class="overlaycontent shadow rounded">
        <div class="" @click="toggleSucursal">
          <img
            class="img-fluid p-4 d-none d-lg-block"
            src="../assets/imgs/datumax/Banner_Desk_Fin_Promo.png"
            alt="Domino's Pizza"
          />
          <img
            class="img-fluid p-4 d-block d-lg-none"
            src="../assets/imgs/datumax/Banner_Mobile_Fin_Promo.png"
            alt="Domino's Pizza"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";
import moment from "moment";

import samsLogo from "../assets/imgs/flow/productos-participantes-sams.png";
import walmartLogo from "../assets/imgs/flow/productos-participantes-walmart.png";

import colgate1 from "../assets/imgs/datumax/productos/colgate-max-white.png";
import walmartPremios from "../assets/imgs/flow/premio-walmart.png";

import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);

import paso1 from "@/assets/imgs/dominos/paso1.png";
import paso1Img from "@/assets/imgs/dominos/paso1-img.png";
import paso2 from "@/assets/imgs/dominos/paso2.png";
import paso2Img from "@/assets/imgs/dominos/paso2-img.png";
import paso3 from "@/assets/imgs/dominos/paso3.png";
import paso3Img from "@/assets/imgs/dominos/paso3-img.png";

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      paso1,
      paso1Img,
      paso2,
      paso2Img,
      paso3,
      paso3Img,
      products: [
        {
          name: "Producto 1",
          description: "Este es el producto 1",
          image: "../assets/imgs/datumax/productos/colgate-max-white.png",
        },
        {
          name: "Producto 2",
          description: "Este es el producto 2",
          image: colgate1,
        },
        {
          name: "Producto 3",
          description: "Este es el producto 3",
          image: colgate1,
        },
        {
          name: "Producto 4",
          description: "Este es el producto 4",
          image: colgate1,
        },
      ],
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        genero: "",
        terminosedad: "",
        terminos: "",
        terminoscondiciones: "",
        medio_de_contacto: "",
        estado: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      showPasswordLogin: false, // Para login
      showPasswordSignup1: false, // Para signup password
      showPasswordSignup2: false, // Para signup confirm
      overlay_sucursal: false,
    };
  },
  mounted: function () {
    // // // if (window.gtag) {
    // // //   window.gtag("event", "conversion", {
    // // //     allow_custom_scripts: true,
    // // //     send_to: "DC-10549239/mx_ma0/latam0+standard",
    // // //   });
    // // // }

    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
    logoSrc() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return samsLogo;
      if (tienda === "walmart") return walmartLogo;
      return "";
    },
    textoTienda() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return "Sam´s Club";
      if (tienda === "walmart") return "Walmart y Bodega Aurrera";
      return "";
    },
    groupedProducts() {
      const groups = [];
      for (let i = 0; i < this.products.length; i += 2) {
        groups.push(this.products.slice(i, i + 2));
      }
      return groups;
    },
  },
  methods: {
    scrollToLogin() {
      this.$nextTick(() => {
        const target = document.getElementById("iniciar-sesion");

        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      });
    },
    toggleSucursal() {
      this.overlay_sucursal = !this.overlay_sucursal;
    },
    trackTerminosClick() {
      try {
        window.gtag("event", "TerminosYCondiciones", {
          send_to: "G-19Y3LCQ4F7",
        });
      } catch (error) {
        console.warn("Error enviando eventos GA4:", error);
      }
    },
    trackWhatsAppClick() {
      try {
        // Meta Pixel
        if (window.fbq) window.fbq("track", "ViewContent");

        // TikTok Pixel
        if (window.ttq && typeof window.ttq.track === "function")
          window.ttq.track("ViewContent");

        // Floodlight
        // // // if (window.gtag) {
        // // //   window.gtag("event", "conversion", {
        // // //     allow_custom_scripts: true,
        // // //     send_to: "DC-10549239/mx_ma0/latam004+standard",
        // // //   });

        // // //   // GA4 event
        // // //   window.gtag("event", "WAClic", {
        // // //     send_to: "G-19Y3LCQ4F7",
        // // //   });
        // // // }

        setTimeout(() => {
          window.open("https://wa.link/pxun4f", "_blank");
        }, 300);
      } catch (error) {
        console.warn("Error enviando eventos a Meta o TikTok:", error);
        window.open("https://wa.link/pxun4f", "_blank");
      }
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1980-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      // Validar contraseña
      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      // Confirmación de contraseña
      if (this.signupForm.password !== this.signupForm.password2) {
        swal.fire(
          "Oops",
          "La confirmación de contraseña no coincide con el campo de contraseña.",
          "warning"
        );
        return false;
      }

      // Validar teléfono
      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      // // Validar edad (18 años o más)
      // if (!this.signupForm.fecha_nacimiento) {
      //   swal.fire("Oops", "Debes ingresar tu fecha de nacimiento.", "warning");
      //   return false;
      // }

      const fechaNacimiento = moment(
        this.signupForm.fecha_nacimiento,
        "YYYY-MM-DD"
      );
      const hoy = moment();
      const edad = hoy.diff(fechaNacimiento, "years");

      if (edad < 18) {
        swal.fire(
          "Oops",
          "Debes tener al menos 18 años para registrarte.",
          "warning"
        );
        return false;
      }

      // Todo validado, registrar
      this.registro();
    },

    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      // // // await this.enviaCorreo(
      // // //   this.signupForm.nombre,
      // // //   this.signupForm.apellido,
      // // //   this.signupForm.email
      // // // );

      await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, email) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        email: email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              await this.$store.dispatch("signup", thes.signupForm);

              thes.$gtag.event("conversion", {
                send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              });

              //window.fbq("track", "CompleteRegistration");

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminosedad: false,
        terminos: false,
        terminoscondiciones: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
